// api.js or api.ts
import axios from "axios";

export const API = axios.create({
  // baseURL: `https://backend.thebrandcabin.com/api/v1/`
  baseURL:"https://api.eventdekho.in/api/v1/"
  // baseURL:"http://localhost:8001/api/v1/"
});

API.interceptors.request.use((config) => {
  const token = JSON.parse(localStorage.getItem('single_vendor_admin_token') || 'null');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    // config.headers["Content-Type"] = 'multipart/form-data'
  }
  return config;
});
// 'Content-Type': 'multipart/form-data',


//User Login
//---------------

export const UserLogin = (cred) => API.post(`admin/admin-signup`,cred);

//User Login
//---------------

export const DashboardApi = () => API.get(`admin/dashboardCountDta` );


//User Management
// *************************************

export const UserManagementApi = (data) => API.get(`admin/customers-list?${data}` );

export const UserDetailsOnIdBasisApi = (id) => API.get(`admin/customer-info/${id}` );

export const ChnageUserStatusApi = ({id,dataItem}) => API.patch(`admin/customer-update/${id}`,dataItem );

export const UserSearchBarApi = (searchKey) => API.get(`admin/customer-searchbar?${searchKey}` )

export const BookingHistoryApi = ({id,dataSet}) => API.get(`admin/customer-previous/${id}?${dataSet}` )



//Banner Management
// *************************************

export const AddBannerApi = (data) => API.post('admin/addbanner',data );

export const GetBannerListApi = (page) => API.get(`admin/bannerlist?${page}` );

export const EditBannerApi = ({id,formData}) => API.put(`admin/updateBanner/${id}`,formData );

export const DeleteBannerApi = (id) => API.delete(`admin/deleteBanner/${id}` );

export const BannerSearchBarApi = (searchKey) => API.get(`admin/banner-searchbar?${searchKey}` )


//deal Banner Management
// *************************************

export const CreateDealBannerApi = (data) => API.post('admin/adddealbanner',data );

export const GetDealBannerListApi = (params) => API.get(`admin/dealbannerlist?${params}` );

export const EditDealBannerApi = ({id,formData}) => API.put(`admin/updatedealBanner/${id}`,formData );

export const DeleteDealBannerApi = (id) => API.delete(`admin/deletedealBanner/${id}` );

export const DealBannerSearchBarApi = (searchKey) => API.get(`admin/dealbanner-searchbar?${searchKey}` )


// product category management
//---------------------------------

export const GetProductCategoryApi = (data) => API.get(`admin/category-list?${data}` );

export const GetProductCategoryListForDropDownApi = (data) => API.get(`admin/categorylisting` );

export const DeleteProductCategoryApi = (id) => API.delete(`admin/category-delete/${id}` );

export const CreateProductCategoryApi = (formData) => API.post('admin/category-insert',formData,{
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const EditProductCategoryApi = ({id,formData}) => API.patch(`admin/category-update/${id}`,formData,{
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

// sub category product management
//---------------------------------

export const GetSubCategoryProductApi = (id) =>API.get(`admin/subcategory-list/${id}` );

export const CreateSubCategoryProductApi = (data) => API.post(`admin/subcategory-insert`,data,{
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const EditSubProductCategoryApi = ({id,formData}) => API.patch(`admin/subcategory-update/${id}`,formData,{
  headers: {
    'Content-Type': 'multipart/form-data',
  },
});

export const DeleteSubProductCategoryApi = (id) => API.delete(`admin/subcategory-delete/${id}` );

//product catalogue
// -------------------

export const CreateProductCatalogueApi = (formData) => API.post(`admin/addnew-product`,formData );

export const GetProductCatalogueApi = (params) => API.get(`admin/getall-products?${params}` );

export const GetProductOnIdBasisApi = (id) => API.get(`admin/getsingle-product/${id}` );

export const DeleteProductApi = (id) => API.delete(`admin/deleteOne-product/${id}` );

export const EditProductApi = ({id,formData}) => API.patch(`admin/updatedetils-product/${id}`,formData );

export const createCustomizeProductApi = (data) => API.post(`admin/createCustom`,data );

export const GetCustomizeProductApi = () => API.get(`admin/listingCustom` );

export const DeleteCustomizeProductApi = (id) => API.delete(`admin/deleteCustom/${id}` );
export const EditCustomizeProductApi = ({id,data}) => API.put(`admin/updateCustom/${id}`,data );





//City Management
//------------------

export const GetCityManagementApi = (params) => API.get(`admin/viewcity?${params}` );

export const AddCityManagementApi = (formData) => API.post(`admin/addcity`,formData );

export const UpdateCityManagementApi = ({id,formData}) => API.patch(`admin/updatecity/${id}`,formData );

export const DeleteCityManagementApi = (id) => API.delete(`admin/deleteCity/${id}` );

//Booking management

export const GetOrderslistBookingManagementApi = (params) => API.get(`admin/orderslist/confirmed?${params}` );

export const GetIntransitBookingManagementApi = () => API.get(`admin/orderslist/in-transit` );

export const GetCancelledOrderslistBookingManagementApi = () => API.get(`admin/orderslist/cancelled` );

export const GetCompletedOrderslistBookingManagementApi = () => API.get(`admin/orderslist/completed` );

export const UpdateDecoratorBookingManagementApi = ({id,iState}) => API.patch(`admin/updateDecorator/${id}`,iState );

export const CancelBookingManagementApi = ({id,data}) => API.patch(`admin/cancelOrder/${id}`,data );

export const UpdateSubStatusManagementIntransitApi = ({id,data}) => API.patch(`admin/updateSubStatus/${id}`,data );

export const UpdateSubStatusManagementCompleteApi = ({id,data}) => API.patch(`admin/updateSubStatus/${id}`,data );

export const ProductDetailsManagementCompleteApi = (id) => API.get(`admin/viewdetails/${id}` );

//Abandoned Cart Managment
//-------------------------

export const GetCustomerAbandonedCartApi = () => API.get(`admin/customerabandonedlist` );

export const GetDetailProductsabandonedApi = (id) => API.get(`admin/detailproductsabandoned/${id}` );

//Content Management

export const GetAboutUsContentManagementApi = () => API.get(`admin/aboutusget` );

export const GetPrivacyPolicyContentManagementApi = () => API.get(`admin/privacyget` );

export const GetTermConditionContentManagementApi = () => API.get(`admin/termget` );

export const GetContactUsManagementApi = () => API.get(`admin/contactdata` );

export const GetCancellationPolicyManagementApi = () => API.get(`admin/returnpolicyget` );

export const GetFAQManagementApi = () => API.get(`admin/faqget` );

export const UpdateAboutUsContentManagementApi = ({id,details}) => API.patch(`admin/aboutupdate/${id}`,{details} );
export const UpdateTermConditionContentManagementApi = ({id,details}) => API.patch(`admin/termupdate/${id}`,{details} );
export const UpdatePrivacyPolicContentManagementApi = ({id,details}) => API.patch(`admin/privacyupdate/${id}`,{details} );

export const UpdateContactUsManagementApi = ({id,details}) => API.patch(`admin/contactupdate/${id}`,{details} );

export const UpdateCancellationPolicyManagementApi = ({id,details}) => API.patch(`admin/returnpolicyupdate/${id}`,{details} );

export const UpdateFAQanagementApi = ({id,details}) => API.patch(`admin/faqupdate/${id}`,{details} );

//Payment management

export const GetPaymentManagementApi = (params) => API.get(`admin/paymentList?${params}` );


//notification management

export const CreateNotificationManagementApi = (data) => API.post(`admin/createNotification`,data );

export const GetNotificationManagementApi = (dataSet) => API.get(`admin/listNotification?${dataSet}` );

export const UpdateNotificationManagementApi = ({id,data}) => API.patch(`admin/updateNotification/${id}`,data );

export const DeleteNotificationManagementApi = (id) => API.delete(`admin/deleteNotification/${id}` );

// sales and analytics

export const TotalSalesSlicesApi = () => API.get(`admin/totalsales` );

export const LeastsellingproductApi = () => API.get(`admin/leastsellingproduct`);

export const TopsellingproductSlicesApi = () => API.get(`admin/topsellingproduct` );

export const TotalusersSlicesApi = () => API.get(`admin/totalusers` );

export const TotalrevenueSlicesApi = () => API.get(`admin/totalrevenue` );

///Account Management

export const viewadminAccountApi = (id) => API.get(`admin/viewadmin/${id}` );

export const UpdateDetailsAccountApi = ({id,data}) => API.patch(`admin/addDetails/${id}`,data);

export const UpdatePasswordAccountApi = (data) => API.patch(`admin/updatePassword`,data);

// Lead Management
//------------------

export const GetAllLeadsApi = () => API.get(`customer/leads`);

export const GetLeadDetailApi = (id) => API.get(`admin/lead-detail/${id}`);

export const UpdateLeadStatusApi = ({ id, data }) => API.patch(`admin/lead-status/${id}`, data);

export const DeleteLeadApi = (id) => API.delete(`admin/lead-delete/${id}`);

export const AddLeadMessageApi = ({ id, data }) => API.post(`admin/lead-message/${id}`, data);

export const AddLeadApi = ( data ) => API.post(`customer/lead`, data);


 // Meta Data Management
// --------------------

export const AddMetaDataApi = (data) => API.post(`admin/add-metadata`, data);
export const GetMetaDataListApi = (data) => API.get(`admin/meta-data-admin${data}`);
export const deleteMetaDataApi = (id) => API.delete(`admin/delete-metadata/${id}`);
export const updateMetaDataApi = (id, data) => API.put(`admin/update-metadata/${id}`, data);
export const getMetaDataByIdApi = (id) => API.get(`admin/meta-data-list/${id}`);

// Event Page Management
// --------------------

export const AddEventPageApi = (data) => API.post(`admin/add-eventpage`, data);
export const GetEventPageListApi = (data) => API.get(`admin/eventpage-admin${data}`);
export const deleteEventPageApi = (id) => API.delete(`admin/delete-eventpage/${id}`);
export const updateEventPageApi = (id, data) => API.put(`admin/update-eventpage/${id}`, data);
export const getEventPageByIdApi = (id) => API.get(`admin/eventpage-list/${id}`);
export const getEventPageReviewsApi = (id) => API.get(`admin/eventpage-reviews/${id}`);
export const addEventPageReviewApi = (id, data) => API.post(`admin/add-eventpage-review/${id}`, data);
export const updateEventPageReviewApi = (id, reviewId, data) => API.put(`admin/update-eventpage-review/${id}/${reviewId}`, data);
export const deleteEventPageReviewApi = (id, reviewId) => API.delete(`admin/delete-eventpage-review/${id}/${reviewId}`);

// Vendor Category Management
// --------------------------

export const GetVendorCategoryApi = (params) => API.get(`admin/vendor-category-list?${params}`);

export const GetVendorCategoryListForDropDownApi = () => API.get(`admin/vendor-category-listing`);

export const CreateVendorCategoryApi = (data) => API.post(`admin/vendor-category-insert`, data);

export const EditVendorCategoryApi = ({ id, data }) => API.patch(`admin/vendor-category-update/${id}`, data);

export const DeleteVendorCategoryApi = (id) => API.delete(`admin/vendor-category-delete/${id}`);

export const VendorCategorySearchBarApi = (searchKey) => API.get(`admin/vendor-category-searchbar?${searchKey}`);

// Vendor City Management
// -----------------------

export const GetVendorCityApi = (params) => API.get(`admin/vendor-city-list?${params}`);

export const GetVendorCityListForDropDownApi = () => API.get(`admin/vendor-city-listing`);

export const AddVendorCityApi = (data) => API.post(`admin/vendor-city-insert`, data);

export const UpdateVendorCityApi = ({ id, data }) => API.patch(`admin/vendor-city-update/${id}`, data);

export const DeleteVendorCityApi = (id) => API.delete(`admin/vendor-city-delete/${id}`);

export const VendorCitySearchBarApi = (searchKey) => API.get(`admin/vendor-city-searchbar?${searchKey}`);

// Vendor Management
// -----------------------

export const GetVendorListApi = (params) => API.get(`admin/vendor-list?${params}`);

export const GetVendorDetailApi = (id) => API.get(`admin/vendor-detail/${id}`);

export const CreateVendorApi = (data) => API.post(`admin/vendor-insert`, data);

export const UpdateVendorApi = ({ id, data }) => API.patch(`admin/vendor-update/${id}`, data);

export const DeleteVendorApi = (id) => API.delete(`admin/vendor-delete/${id}`);